// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body.disable-animations * {\n  -o-transition-property: none !important;\n  -moz-transition-property: none !important;\n  -ms-transition-property: none !important;\n  -webkit-transition-property: none !important;\n  transition-property: none !important;\n}\n@flags-url : flagSprite.png;\n", ""]);
// Exports
module.exports = exports;
